// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".myCustomStyle[data-v-3ed24b89] {\n  border: 1px solid rgb(210, 214, 220);\n}\n.myCustomStyle[data-v-3ed24b89]:hover {\n  background: #1EB5F0;\n}\n.myCustomStyle:hover svg[data-v-3ed24b89] {\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
